// extracted by mini-css-extract-plugin
module.exports =  {"link":"RouterLink__link--VM Link__link--ZK","button":"RouterLink__button--S9","disabled":"RouterLink__disabled--qh"};